import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { XCircle } from "lucide-react";

/**
 * Big, high-contrast, animated "INCORRECT" indicator. Render once per match
 * screen and bump `trigger` (an incrementing number) whenever a wrong answer is
 * submitted — a large shaking red ✗ flashes center-screen so the player can't
 * miss it. Non-interactive overlay; auto-dismisses.
 */
export default function IncorrectFlash({ trigger }) {
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (!trigger) return undefined;
    setShow(true);
    const t = setTimeout(() => setShow(false), 950);
    return () => clearTimeout(t);
  }, [trigger]);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-[130] pointer-events-none grid place-items-center"
          data-testid="incorrect-flash"
        >
          <motion.div
            initial={{ scale: 0.4, rotate: -8 }}
            animate={{ scale: [0.4, 1.18, 1], rotate: [-8, 6, 0], x: [0, -14, 14, -9, 9, 0] }}
            transition={{ duration: 0.6, ease: "easeOut" }}
            className="flex flex-col items-center"
          >
            <XCircle
              className="text-rose-500"
              style={{ width: 168, height: 168, filter: "drop-shadow(0 0 34px rgba(244,63,94,0.85))" }}
              strokeWidth={2.5}
            />
            <div
              className="mt-2 font-heading font-black text-4xl sm:text-6xl text-rose-500 tracking-wider"
              style={{ textShadow: "0 0 26px rgba(244,63,94,0.75)" }}
            >
              INCORRECT
            </div>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
